import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  cardMargin: {
    marginBottom: "15px",
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    alignItems: "center",
    textAlign: "center",
  },
  "& .mantine-Container-root": {
    paddingLeft: "0!important",
    paddingRight: "0!important",
  },
  settingIcon: {
    color: "#232323",
    display: "flex",
    width: "40px",
    height: "40px",
    justifyContent: "center",
    alignItems: "center",
  },
  textMargin: {
    margin: 0,
  },
  titleMargin: {
    margin: "5px 0",
  },
}));

export default useStyles;
